import { Box, Card, Container, Typography } from '@mui/material';
import React from 'react';
import { Link } from 'react-router-dom';

import cervejaria1 from 'assets/icons/cervejaria1.jpeg';
import cervejaria2 from 'assets/icons/cervejaria2.jpeg';
import SEOHead from 'components/SEOHead';

const QuemSomos = () => (
  <Box sx={{ minHeight: '60vh' }}>
    <SEOHead
      title="Quem somos | Clube da 42 - Cervejaria Avenida 42"
      description="Conheça a Avenida 42 e o Clube da 42: nossa cervejaria, nosso Brewpub em Araraquara/SP e o clube de assinatura que leva cervejas artesanais selecionadas até você."
      keywords="Avenida 42, cervejaria, Clube da 42, Brewpub 42, Araraquara, cerveja artesanal"
    />

    {/* Hero */}
    <Box
      sx={{
        background: 'linear-gradient(135deg, #f98f08 0%, #e67a00 100%)',
        color: '#fff',
        py: { xs: 6, md: 8 },
        px: 2,
      }}
    >
      <Container maxWidth="md">
        <Typography
          variant="h3"
          component="h1"
          sx={{
            fontWeight: 800,
            textAlign: 'center',
            mb: 2,
            textShadow: '0 1px 2px rgba(0,0,0,0.1)',
          }}
        >
          Quem somos
        </Typography>
        <Typography
          variant="h5"
          sx={{
            textAlign: 'center',
            fontStyle: 'italic',
            opacity: 0.95,
          }}
        >
          A Avenida 42 e o Clube da 42
        </Typography>
      </Container>
    </Box>

    <Container maxWidth="md" sx={{ py: 5 }}>
      {/* Seção A Cervejaria - fotos + texto */}
      <Box sx={{ mb: 6 }}>
        <Typography
          variant="h4"
          component="h2"
          sx={{
            fontWeight: 700,
            mb: 3,
            color: 'text.primary',
            textAlign: 'center',
          }}
        >
          A Cervejaria
        </Typography>
        <Box
          sx={{
            display: 'grid',
            gridTemplateColumns: { xs: '1fr', md: '1fr 1fr' },
            gap: 2,
            mb: 3,
          }}
        >
          <Box
            component="img"
            src={cervejaria1}
            alt="Cervejaria Avenida 42 - interior"
            sx={{
              width: '100%',
              height: { xs: 460, sm: 580 },
              objectFit: 'cover',
              borderRadius: 3,
              boxShadow: '0 4px 20px rgba(0,0,0,0.1)',
            }}
          />
          <Box
            component="img"
            src={cervejaria2}
            alt="Cervejaria Avenida 42 - espaço"
            sx={{
              width: '100%',
              height: { xs: 460, sm: 580 },
              objectFit: 'cover',
              borderRadius: 3,
              boxShadow: '0 4px 20px rgba(0,0,0,0.1)',
            }}
          />
        </Box>
        <Typography
          variant="body1"
          sx={{ lineHeight: 1.85, color: 'text.primary' }}
        >
          A Avenida 42 nasceu da vontade de fazer cerveja do jeito que
          acreditamos. Já são 11 anos de história em Araraquara-SP, onde
          mantemos nossa fábrica e brewpub, lugar onde tudo acontece: das
          receitas que saem do papel aos copos que chegam à mesa. Desde o
          começo, nossa proposta sempre foi simples — produzir cervejas sem
          frescura, longe do mainstream e dos modismos passageiros. Fazemos as
          cervejas que realmente gostamos de beber: bem feitas, honestas e
          cheias de personalidade. Esse mesmo espírito é o que move o Clube da
          42, levando para cada caixa um pouco daquilo que criamos e vivemos
          todos os dias por aqui. 🍻
        </Typography>
      </Box>

      {/* Card principal - mesmo conteúdo da seção Clube da 42? */}
      <Card
        sx={{
          display: 'flex',
          flexDirection: { xs: 'column', sm: 'row' },
          borderRadius: 4,
          overflow: 'hidden',
          boxShadow: '0 8px 32px rgba(0,0,0,0.12)',
          mb: 5,
        }}
      >
        <Box
          sx={{
            flex: { xs: 'none', sm: '1' },
            minHeight: { xs: 240, sm: 'auto' },
            display: 'flex',
          }}
        >
          <Box
            component="img"
            src="https://firebasestorage.googleapis.com/v0/b/clube-42-3baa5.firebasestorage.app/o/homem_segurando_caixa_30.png?alt=media&token=4c171790-04aa-4762-a83e-c6a8e2718612"
            alt="Clube da 42"
            sx={{
              width: '100%',
              height: '100%',
              objectFit: 'cover',
            }}
          />
        </Box>
        <Box
          sx={{
            flex: { xs: 'none', sm: 2 },
            backgroundColor: '#f98f08',
            color: '#fff',
            p: 3,
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
          }}
        >
          <Typography
            variant="h4"
            component="h2"
            sx={{ fontWeight: 'bold', mb: 2 }}
          >
            Clube da 42?
          </Typography>
          <Typography variant="h6" sx={{ mb: 2, fontStyle: 'italic' }}>
            Mais do que uma assinatura, uma experiência cervejeira exclusiva.
          </Typography>
          <Typography variant="body1" sx={{ mb: 2, lineHeight: 1.7 }}>
            Nosso propósito é simples: entregar a você cervejas artesanais
            autorais, produzidas em lotes únicos e limitados, criadas
            especialmente para membros do clube. Todo mês, você recebe rótulos
            inéditos, irrepetíveis e fora do mercado tradicional — cervejas
            desenvolvidas com identidade, criatividade e personalidade, feitas
            para quem valoriza exclusividade de verdade.
          </Typography>
          <Typography
            variant="body1"
            sx={{ fontStyle: 'italic', textAlign: 'center' }}
          >
            No Clube da 42, cada caixa é uma edição única.
            <br />
            <strong>Bebeu, viveu. Acabou, virou história.</strong>
          </Typography>
        </Box>
      </Card>

      {/* Visite o Brewpub */}
      <Box sx={{ mb: 4 }}>
        <Typography
          variant="h5"
          component="h2"
          sx={{ fontWeight: 700, mb: 2, color: 'text.primary' }}
        >
          Visite o Brewpub 42
        </Typography>
        <Typography variant="body1" sx={{ lineHeight: 1.8 }}>
          Em Araraquara/SP você pode nos visitar no <strong>Brewpub 42</strong>,
          nosso espaço para provar os rótulos da casa, petiscar e aproveitar a
          boa mesa. Assinantes do Clube da 42 ganham descontos exclusivos no
          Brewpub e na nossa loja.
        </Typography>
      </Box>

      {/* CTA */}
      <Box sx={{ textAlign: 'center', mt: 5 }}>
        <Link
          to="/"
          style={{
            color: '#f98f08',
            fontWeight: 600,
            textDecoration: 'none',
            fontSize: '1rem',
          }}
        >
          Conheça os planos do Clube da 42 →
        </Link>
      </Box>

      <Box sx={{ mt: 4, textAlign: 'center' }}>
        <Link to="/" style={{ color: 'inherit', fontSize: '0.875rem' }}>
          ← Voltar ao início
        </Link>
      </Box>
    </Container>
  </Box>
);

export default QuemSomos;
